export default "__VITE_ASSET__9RG1oBcJ__"